import _ from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { Checkbox, Col, Row, Spin, Typography } from 'antd';

import { AppStore, CarStore } from 'stores';
import { UserObject } from 'stores/Classes';

import { PitstopModal } from 'shared';
import { showDemoVinOrRealVin } from 'shared/utils';

import SelectCars from './SelectCars';
import SelectedCars from './SelectedCars';

import styled from 'styled-components';
const { Text } = Typography;

const StyledModal = styled(PitstopModal)`
  && {
    .ant-modal-header {
      .ant-modal-title {
        color: #02103d;
      }
    }
  }
`;

const textStyle = {
  fontSize: '15px',
};

const SaveUserCarsModal = ({ user, id, onSaveModal }) => {
  const [modalState, setModalState] = useState({
    selectAllVehicles: false,
    selectedCars: [],
  });

  const { selectAllVehicles, selectedCars } = modalState;

  useEffect(() => {
    const updateUserCars = async () => {
      if (!user) return;

      if (user.cars.length === user.totalCarsAssociated) {
        setModalState((prev) => ({
          ...prev,
          selectedCars: user.cars.slice(0),
        }));
      } else {
        setModalState((prev) => ({ ...prev, selectedCars: [] }));
        await user.getCars({ limit: user.totalCarsAssociated });
        setModalState((prev) => ({
          ...prev,
          selectedCars: user.cars.slice(0),
        }));
      }
    };

    updateUserCars();
  }, [user]);

  useEffect(() => {
    if (!user && AppStore.openModals.get(id)) {
      setModalState((prev) => ({ ...prev, selectedCars: [] }));
      AppStore.openModals.set(id, false);
    }
  }, [user, id]);

  const saveCars = async () => {
    if (!user) return;

    let storedCars = user.cars.slice();

    try {
      if (selectAllVehicles) {
        await user.assignAllFleetVehicles();
      } else {
        storedCars.map(async (id) => {
          if (selectedCars.indexOf(id) < 0) {
            await user.unassignCarId(id);
          }
        });
        if (!_.isEmpty(selectedCars)) {
          await user.setCarIds(selectedCars);
        }
      }
      AppStore.openModals.set(id, false);
      onSaveModal?.();
    } catch (e) {
      console.log(e);
    }
  };

  const onSelect = (ids) => {
    setModalState((prev) => ({
      ...prev,
      selectedCars: ids,
    }));
  };

  const onUnselect = (car) => {
    setModalState((prev) => ({
      ...prev,
      selectedCars: prev.selectedCars.filter((id) => id !== car.id),
    }));
  };

  const cars = _.chain(selectedCars)
    .map((id) => CarStore.data.get(id))
    .map((car) => ({
      ...car,
      vin: showDemoVinOrRealVin(car.vin),
    }))
    .value();

  return (
    <StyledModal
      id={id}
      confirmOkMessage="Are you sure you want to save these cars?"
      failureMessage="Failed to save cars"
      successMessage="Saved cars successfully"
      title="Select Vehicle"
      width={1200}
      onOk={saveCars}
      centered={true}
      okText={'Save'}
      afterClose={() =>
        setModalState((prev) => ({ ...prev, selectAllVehicles: false }))
      }
    >
      <Row gutter={[0, 15]}>
        <Col>
          <Text
            style={textStyle}
          >{`User: ${user ? user.name : 'Loading'}`}</Text>
        </Col>
      </Row>
      {CarStore.getCarsForUserPending ? (
        <Spin />
      ) : (
        <>
          <Row gutter={[0, 15]}>
            <Col>
              <Checkbox
                style={textStyle}
                checked={selectAllVehicles}
                onChange={(e) =>
                  setModalState((prev) => ({
                    ...prev,
                    selectAllVehicles: e.target.checked,
                  }))
                }
              >
                Select All vehicles
              </Checkbox>
            </Col>
          </Row>

          {!selectAllVehicles && (
            <>
              <Row gutter={[0, 15]}>
                <Col>
                  <SelectedCars
                    fontSize={'18px'}
                    cars={cars}
                    onUnselect={onUnselect}
                  />
                </Col>
              </Row>
              <Row gutter={[0, 15]}>
                <Col>
                  <SelectCars
                    rowSelection={{
                      selectedCarIds: selectedCars || user?.cars,
                      onChange: onSelect,
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </StyledModal>
  );
};

SaveUserCarsModal.propTypes = {
  user: PropTypes.instanceOf(UserObject),
  id: PropTypes.string.isRequired,
  onSaveModal: PropTypes.func,
};

export default observer(SaveUserCarsModal);
